module.exports = __webpack_public_path__ + "img/vertical_3_3_3.94d1da2a.png";